// extracted by mini-css-extract-plugin
export default {"title":"OptionsItem_title__tvXjQ","text":"OptionsItem_text__q5v3h","optionsItem":"OptionsItem_optionsItem__nhper","optionsItemActive":"OptionsItem_optionsItemActive__40QLr"};